export const PATIENT_LEAD_STATUSES = {
  UNQUALIFIED: 'Unqualified',
  QUALIFIED: 'Qualified',
  CONVERTED: 'Converted',
  PARTIALLY_CREATED: 'Patient Partially Created',
  NEW: 'New',
};
